/* Neutral UI runtime shared by the staff islands AND the customer portal:
 * the React hooks and the colour tokens, nothing else.
 *
 * The quoting toolkit (src/newquote/pieces, dg_picker, inputs, services,
 * quote_meta) used to import these from src/common.js, the STAFF runtime
 * (Sidebar / useMe / ELCAPP_NAV). The portal bundle must never embed staff
 * code (tests/test_portal_page.py), so the toolkit could not be reused there
 * and the portal grew its own drifting copy of the cargo table. Since
 * 2026-11-03 the toolkit depends only on this file; src/common.js and
 * src/portal/common.js both re-export C from here, so there is one palette.
 *
 * React is a runtime global (vendored UMD script loaded by every shell). */

const { useState, useEffect, useLayoutEffect, useMemo, useRef } = React;

const C = {
  bg:'#f8fafc', s1:'#f1f5f9', s2:'#ffffff', s3:'#e2e8f0',
  brd:'rgba(0,0,0,0.08)',
  blue:'#2563eb', blueL:'#2563eb',
  gold:'#d97706', goldL:'#d97706',
  text:'#0f172a', textM:'#475569', textD:'#94a3b8',
  green:'#059669', red:'#dc2626',
};

export { useState, useEffect, useLayoutEffect, useMemo, useRef, C };
